import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3i3gsl3t: FaireBrandEntity = {
  token: "b_3i3gsl3t",
  type: "brand",
  name: "JACK HENRY",
  avatarUrl:
    "https://cdn.faire.com/fastly/cdc92f9446798a79d393003e39161e39292ba44d7a0bf712a692d5734b8dff50.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c3476702038ff477dc3a16a2f78e6896d5bba07218a5c084c7993bb16ee2ddd9.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/cdc92f9446798a79d393003e39161e39292ba44d7a0bf712a692d5734b8dff50.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c3476702038ff477dc3a16a2f78e6896d5bba07218a5c084c7993bb16ee2ddd9.webp",
  location: "Carlsbad, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "We are Jack Henry, a self-care and wellness brand based in Costa Mesa, CA. We have created a plant-based collection of full body care products sourced from the purest ingredients on the planet, designed to feed the microbiome and bring balance. We also have a wellness club and offer services focused on education and functionality.\n\nWe stand out for our commitment to clean, organic ingredients and high-quality grooming products. Founded on the principle of offering safe alternatives to traditional personal care items, we emphasize simplicity, transparency, and effectiveness in our formulations. From hair care to skincare and fragrances, our product line reflects our core values. Each product is carefully crafted with minimal, organic, and sustainably sourced ingredients, free from harmful chemicals like parabens, phthalates, and sulfates. Our focus on purity extends to our manufacturing process, ensuring that every product is made with integrity and environmental responsibility.\n\nWhat sets us apart is our commitment to education. We aim to inform consumers about the importance of clean ingredients and their impact on personal health and the environment. This dedication to transparency and advocacy resonates with consumers seeking authentic, ethical brands that align with their values.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:57.279Z",
    importedBy: "entity-db-cli",
  },
};
